import {
  Container,
  Typography,
  Button,
  Grid,
  Box,
  Card,
  CardContent
} from "@mui/material";
import { keyframes } from "@mui/system";

import PhoneAndroidIcon from "@mui/icons-material/PhoneAndroid";
import WifiTetheringIcon from "@mui/icons-material/WifiTethering";
import PublicIcon from "@mui/icons-material/Public";
import ShowChartIcon from "@mui/icons-material/ShowChart";
// import NotificationsIcon from "@mui/icons-material/Notifications";
import DevicesIcon from "@mui/icons-material/Devices";

import ChildCareIcon from "@mui/icons-material/ChildCare";
import PetsIcon from "@mui/icons-material/Pets";
import DnsIcon from "@mui/icons-material/Dns";
import GrassIcon from "@mui/icons-material/Grass";
import { useEffect, useState } from "react";

import bgImage from "../assets/img/0700.jpg";
import AdBanner from "../AdBanner";
import { useTranslation } from "react-i18next";

// ADD THIS just after imports
const isPrerender =
  typeof navigator !== "undefined" &&
  navigator.userAgent === "ReactSnap";

const SEO_TEMP = "23.8°C";
const SEO_LOCATION = "Natchez(United States)";

//error - in middle of SEO from AI

export default function Home() {
  const { t } = useTranslation();

  const [temp, setTemp] = useState("--");
  // const [lastUpdated, setLastUpdated] = useState("");
  const [location, setLocation] = useState("--");
  const unit = getTemperatureUnit();
  useEffect(() => {
    const fetchData = () => {
      fetch("https://roomtemperature.io/api/live/")
        .then(res => res.json())
        .then(data => {
          if (data) {
            setTemp(data.temperature);
            // setLastUpdated(data.date);
            setLocation(data.location);
          }
        })
        .catch(() => { });
    };

    fetchData();
    const interval = setInterval(fetchData, 60000); // every 10 sec

    return () => clearInterval(interval);
  }, []);

  const breathe = keyframes`
  0% {
    transform: scale(1);
    opacity: 0.9;
    text-shadow: 0 0 10px rgba(255,255,255,0.4);
  }
  50% {
    transform: scale(1.01);
    opacity: 1;
    text-shadow: 0 0 25px rgba(255,255,255,0.7);
  }
  100% {
    transform: scale(1);
    opacity: 0.9;
    text-shadow: 0 0 10px rgba(255,255,255,0.4);
  }`;

  const livePulse = keyframes`
  0% {
    transform: scale(0.9);
    opacity: 0.6;
    box-shadow: 0 0 0px rgba(0,255,0,0.4);
  }
  50% {
    transform: scale(1.0);
    opacity: 1;
    box-shadow: 0 0 12px rgba(0,255,0,0.9);
  }
  100% {
    transform: scale(0.9);
    opacity: 0.6;
    box-shadow: 0 0 0px rgba(0,255,0,0.4);
  }`;

  return (
    <Box>

      {/* HERO */}
      <Box
        sx={{
          position: "relative",
          color: "#fff",
          py: 12,
          textAlign: "center",
          backgroundImage: `url(${bgImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center"
        }}
      >

        {/* Overlay */}
        <Box
          sx={{
            position: "absolute",
            inset: 0,
            background: "linear-gradient(180deg, rgba(0,0,0,0.3), rgba(0,0,0,0.85))"
          }}
        />

        <Container sx={{ position: "relative", zIndex: 2 }}>
          <Box
            component="img"
            src="/logo512.png"
            alt="logo"
            sx={{ width: 110, mb: 2 }}
          />

          <Typography variant="h3" component="h1" fontWeight="bold" gutterBottom>
            {t("turn2liveMon")}
          </Typography>

          <Typography variant="h6" component="h3" sx={{ mb: 4 }}>
            {t("trackAnyWhere")}
          </Typography>

          <Button
            variant="contained"
            sx={{ m: 1 }}
            href="https://play.google.com/store/apps/details?id=asav.roomtemprature"
            target="_blank">
            {t("download")}
          </Button>
          <Button
            variant="outlined"
            sx={{ m: 1, color: "#fff", borderColor: "#fff" }}
            href="https://mastertechnologis.com/room-temperature/login.php">
            {t("login")}
          </Button>


          <Typography variant="body2" component="p" sx={{ mt: 3, opacity: 0.8 }}>
            {t("worksNoSensor")}
          </Typography>

          <Box sx={{ mt: 4 }}>

            {/* 🌡️ Temperature */}
            <Typography
              variant="h2"
              fontWeight="bold"
              sx={{
                animation: `${breathe} 4s ease-in-out infinite`,
                display: "inline-block",
                transition: "all 0.3s ease" // 👈 STEP 4 here
              }}
            >
              {isPrerender
                ? SEO_TEMP
                : temp === "--"
                  ? "..."
                  : unit === "C"
                    ? `${temp}°C`
                    : `${(temp * 9 / 5 + 32).toFixed(1)}°F`}
            </Typography>

            {/* 🟢 LIVE DOT (STEP 3) */}
            <Box
              sx={{
                mt: 1,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: 1
              }}
            >
              <Box
                sx={{
                  width: 10,
                  height: 10,
                  borderRadius: "50%",
                  bgcolor: "lime",
                  animation: `${livePulse} 2.0s ease-in-out infinite`
                }}
              />
              <Typography variant="body2" component="p" sx={{ opacity: 0.8 }}>
                {t("liveFrom")}<i>{isPrerender ? SEO_LOCATION : location}</i>
              </Typography>
            </Box>

            {/* Info text */}


            {/* <Typography variant="caption" sx={{ opacity: 0.6 }}>
    Last updated: {lastUpdated}
  </Typography> */}

          </Box>

        </Container>
      </Box>

      <Box sx={{ textAlign: "center", py: 2, bgcolor: "#000", color: "#aaa" }}>
        <Typography variant="body2">
          {t("trustedBy")}
        </Typography>
      </Box>

      {/* HOW IT WORKS */}
      <Container maxWidth="lg" sx={{ py: 10, textAlign: "center" }}>
        <Typography variant="h2" component="h2" gutterBottom>
          {t("howWrk")}
        </Typography>

        <Grid container spacing={4} mt={2} justifyContent="center">
          {[
            {
              icon: <PhoneAndroidIcon sx={{ fontSize: 40 }} />,
              title: "installAppTitle",
              desc: "installAppDesc"
            },
            {
              icon: <WifiTetheringIcon sx={{ fontSize: 40 }} />,
              title: "placePhoneTitle",
              desc: "placePhoneDesc"
            },
            {
              icon: <PublicIcon sx={{ fontSize: 40 }} />,
              title: "monitorAnywhereTitle",
              desc: "monitorAnywhereDesc"
            }
          ].map((item, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Box textAlign="center">
                <Box sx={{ mb: 1, color: "primary.main" }}>{item.icon}</Box>
                <Typography variant="h6">{t(item.title)}</Typography>
                <Typography variant="body2">{t(item.desc)}</Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Container>

      {/* ADSENSE */}
      <Box
        sx={{
          maxWidth: 1000,
          mx: "auto",
          px: 2,
          py: 4
        }}>
        <AdBanner />
      </Box>

      {/* FEATURES */}
      <Box sx={{ bgcolor: "#f5f5f5", py: 10 }}>
        <Container maxWidth="lg">
          <Typography variant="h2" component="h2" textAlign="center" gutterBottom>
            {t("features")}
          </Typography>

          <Grid container spacing={4} mt={2} justifyContent="center">
            {[
              {
                icon: <DevicesIcon sx={{ fontSize: 40 }} />,
                text: "featureNoSensor"
              },
              {
                icon: <ShowChartIcon sx={{ fontSize: 40 }} />,
                text: "featureHistoryGraphs"
              },
              {
                icon: <WifiTetheringIcon sx={{ fontSize: 40 }} />,
                text: "featureLiveDashboard"
              }
              // ,
              // {
              //   icon: <NotificationsIcon sx={{ fontSize: 40 }} />,
              //   text: "Smart alerts (coming soon)"
              // }
            ].map((item, index) => (
              <Grid item xs={12} sm={6} md={3} key={index}>
                <Card
                  sx={{
                    p: 2,
                    textAlign: "center",
                    transition: "0.3s",
                    "&:hover": {
                      transform: "translateY(-5px)",
                      boxShadow: 6
                    }
                  }}
                >
                  <CardContent>
                    <Box sx={{ mb: 1, color: "primary.main" }}>
                      {item.icon}
                    </Box>
                    <Typography>{t(item.text)}</Typography>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>

      {/* USE CASES */}
      <Container maxWidth="lg" sx={{ py: 10 }}>
        <Typography variant="h2" component="h2" textAlign="center" gutterBottom>
          {t("useCases")}
        </Typography>

        <Grid container spacing={4} mt={2} justifyContent="center">
          {[
            {
              icon: <ChildCareIcon sx={{ fontSize: 40 }} />,
              text: "useCaseBabyRoom"
            },
            {
              icon: <PetsIcon sx={{ fontSize: 40 }} />,
              text: "useCasePetSafety"
            },
            {
              icon: <DnsIcon sx={{ fontSize: 40 }} />,
              text: "useCaseServerRoom"
            },
            {
              icon: <GrassIcon sx={{ fontSize: 40 }} />,
              text: "useCaseGreenhouse"
            }
          ].map((item, index) => (
            <Grid item xs={12} sm={6} md={3} key={index}>
              <Card
                sx={{
                  p: 2,
                  textAlign: "center",
                  transition: "0.3s",
                  "&:hover": {
                    transform: "translateY(-5px)",
                    boxShadow: 6
                  }
                }}
              >
                <CardContent>
                  <Box sx={{ mb: 1, color: "primary.main" }}>
                    {item.icon}
                  </Box>
                  <Typography>{t(item.text)}</Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>

      {/* SEO CONTENT */}
      <Box sx={{ bgcolor: "#fafafa", py: 10 }}>
        <Container maxWidth="md">

          <Typography
            variant="h4"
            component="h2"
            gutterBottom
            fontWeight="bold"
          >
            {t("checkRoomTemperatureOnline")}
          </Typography>

          <Typography paragraph>
            {t("roomTemperatureDescription")}
          </Typography>

          <Typography paragraph>
            {t("roomTemperatureDescription2")}
          </Typography>

          <Typography paragraph>
            {t("liveTemperatureDescription")}            
          </Typography>

          <Typography
            variant="h4"
            component="h2"
            gutterBottom
            fontWeight="bold"
            sx={{ mt: 6 }}
          >
            {t("liveRoomTemperatureMonitor")}
          </Typography>

          <Typography paragraph>
            {t("liveRoomTemperatureMonitorDescription")}            
          </Typography>

          <Typography paragraph>
            {t("remoteTemperatureMonitoringDescription")}
          </Typography>

          <Typography
            variant="h4"
            component="h2"
            gutterBottom
            fontWeight="bold"
            sx={{ mt: 6 }}
          >
            {t("roomTemperatureMeasurementOnline")}
          </Typography>

          <Typography paragraph>
            {t("roomTemperatureMeasurementOnlineDescription")}
          </Typography>

          <Typography paragraph>
            {t("temperatureMonitoringImportanceDescription")}
          </Typography>

          <Typography
            variant="h4"
            component="h2"
            gutterBottom
            fontWeight="bold"
            sx={{ mt: 6 }}
          >
            {t("checkRoomTemperatureWithYourPhone")}
          </Typography>

          <Typography paragraph>
            {t("checkRoomTemperatureWithPhoneDescription")}
          </Typography>

          <Typography paragraph>
            {t("roomTemperatureAppDescription")}
          </Typography>

          <Box sx={{ mt: 6 }}>
            <Typography variant="h4" component="h2" gutterBottom>
              {t("frequentlyAskedQuestions")}
            </Typography>

            <Box sx={{ mb: 4 }}>
              <Typography variant="h6" component="h3">
                {t("canICheckRoomTemperatureOnlineForFree")}
              </Typography>
              <Typography>
                {t("roomTempIoAccess")}
              </Typography>
            </Box>

            <Box sx={{ mb: 4 }}>
              <Typography variant="h6" component="h3">
                {t("myRoomTempOnline")}
              </Typography>
              <Typography>
                {t("liveTempView")}
              </Typography>
            </Box>

            <Box sx={{ mb: 4 }}>
              <Typography variant="h6" component="h3">
                {t("canPhoneMeasureRoomTemp")}
              </Typography>
              <Typography>
                {t("phoneTempAssist")}
              </Typography>
            </Box>
          </Box>

        </Container>



      </Box>

      <Box sx={{ py: 10, bgcolor: "#ffffff" }}>
        <Container maxWidth="md">

          <Typography
            variant="h4"
            component="h2"
            gutterBottom
            fontWeight="bold"
            textAlign="center"
          >
            {t("aboutRoomTemperatureIo")}
          </Typography>

          <Typography paragraph>
            {t("roomTempIoAbout")}
          </Typography>

          <Typography paragraph>
            {t("roomTempUseCases")}
          </Typography>

          <Typography paragraph>
            {t("roomTempEducation")}
          </Typography>

          <Typography paragraph>
            {t("tempMonitoringGoal")}
          </Typography>

        </Container>
      </Box>

      {/* LEARN MORE */}
      <Box sx={{ py: 8, bgcolor: "#f8f9fa" }}>
        <Container maxWidth="md">
          <Typography
            variant="h4"
            component="h2"
            gutterBottom
            textAlign="center"
            fontWeight="bold"
          >
            {t("learnMoreRoomTemp")}
          </Typography>

          <Typography paragraph textAlign="center">
            {t("exploreRoomTempGuides")}
          </Typography>

          <Grid container spacing={2} sx={{ mt: 2 }}>
            <Grid item xs={12} sm={6}>
              <a
                href="/what-is-room-temperature"
                style={{ textDecoration: "none" }}
              >
                <Card
                  sx={{
                    height: "100%",
                    transition: "0.3s",
                    "&:hover": {
                      boxShadow: 4,
                      transform: "translateY(-2px)"
                    }
                  }}
                >
                  <CardContent>
                    <Typography variant="h6">
                      {t("whatIsRoomTemperature")}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      {t("roomTempMeaningImportance")}
                    </Typography>
                  </CardContent>
                </Card>
              </a>
            </Grid>

            <Grid item xs={12} sm={6}>
              <a
                href="/how-to-check-room-temperature-online"
                style={{ textDecoration: "none" }}
              >
                <Card
                  sx={{
                    height: "100%",
                    transition: "0.3s",
                    "&:hover": {
                      boxShadow: 4,
                      transform: "translateY(-2px)"
                    }
                  }}
                >
                  <CardContent>
                    <Typography variant="h6">
                      {t("howToCheckRoomTempOnline")}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      {t("roomTempMethods")}
                    </Typography>
                  </CardContent>
                </Card>
              </a>
            </Grid>

            <Grid item xs={12} sm={6}>
              <a
                href="/live-room-temperature"
                style={{ textDecoration: "none" }}
              >
                <Card
                  sx={{
                    height: "100%",
                    transition: "0.3s",
                    "&:hover": {
                      boxShadow: 4,
                      transform: "translateY(-2px)"
                    }
                  }}
                >
                  <CardContent>
                    <Typography variant="h6">
                      {t("liveRoomTempMonitoring")}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      {t("liveRoomTempHowItWorks")}
                    </Typography>
                  </CardContent>
                </Card>
              </a>
            </Grid>

            <Grid item xs={12} sm={6}>
              <a
                href="/room-temperature-measurement-online"
                style={{ textDecoration: "none" }}
              >
                <Card
                  sx={{
                    height: "100%",
                    transition: "0.3s",
                    "&:hover": {
                      boxShadow: 4,
                      transform: "translateY(-2px)"
                    }
                  }}
                >
                  <CardContent>
                    <Typography variant="h6">
                      {t("roomTempMeasurementOnline")}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      {t("roomTempMethodsAccuracyApps")}
                    </Typography>
                  </CardContent>
                </Card>
              </a>
            </Grid>

            <Grid item xs={12} sm={6}>
              <a
                href="/ideal-room-temperature-for-sleeping"
                style={{ textDecoration: "none" }}
              >
                <Card
                  sx={{
                    height: "100%",
                    transition: "0.3s",
                    "&:hover": {
                      boxShadow: 4,
                      transform: "translateY(-2px)"
                    }
                  }}
                >
                  <CardContent>
                    <Typography variant="h6">
                      {t("idealRoomTempSleep")}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      {t("sleepTempGuide")}
                    </Typography>
                  </CardContent>
                </Card>
              </a>
            </Grid>

            <Grid item xs={12} sm={6}>
              <a
                href="/humidity-vs-temperature"
                style={{ textDecoration: "none" }}
              >
                <Card
                  sx={{
                    height: "100%",
                    transition: "0.3s",
                    "&:hover": {
                      boxShadow: 4,
                      transform: "translateY(-2px)"
                    }
                  }}
                >
                  <CardContent>
                    <Typography variant="h6">
                      {t("humidityVsTemperature")}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      {t("humidityVsTempExplain")}
                    </Typography>
                  </CardContent>
                </Card>
              </a>
            </Grid>
            <Grid item xs={12} sm={6}>
              <a
                href="/room-temperature-for-babies"
                style={{ textDecoration: "none" }}
              >
                <Card
                  sx={{
                    height: "100%",
                    transition: "0.3s",
                    "&:hover": {
                      boxShadow: 4,
                      transform: "translateY(-2px)"
                    }
                  }}
                >
                  <CardContent>
                    <Typography variant="h6">
                      {t("roomTempForBabies")}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      {t("nurseryTempGuide")}
                    </Typography>
                  </CardContent>
                </Card>
              </a>
            </Grid>

            <Grid item xs={12} sm={6}>
              <a
                href="/my-room-temperature-online"
                style={{ textDecoration: "none" }}
              >
                <Card
                  sx={{
                    height: "100%",
                    transition: "0.3s",
                    "&:hover": {
                      boxShadow: 4,
                      transform: "translateY(-2px)"
                    }
                  }}
                >
                  <CardContent>
                    <Typography variant="h6">
                      {t("myRoomTempOnline")}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      {t("onlineRoomTempMonitoringHow")}
                    </Typography>
                  </CardContent>
                </Card>
              </a>
            </Grid>

            <Grid item xs={12} sm={6}>
              <a
                href="/room-temperature-website"
                style={{ textDecoration: "none" }}
              >
                <Card
                  sx={{
                    height: "100%",
                    transition: "0.3s",
                    "&:hover": {
                      boxShadow: 4,
                      transform: "translateY(-2px)"
                    }
                  }}
                >
                  <CardContent>
                    <Typography variant="h6">
                      {t("roomTempWebsite")}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      {t("roomTempWebsiteHow")}
                    </Typography>
                  </CardContent>
                </Card>
              </a>
            </Grid>
            <Grid item xs={12} sm={6}>
              <a href="/blog" style={{ textDecoration: "none" }}>
                <Card
                  sx={{
                    height: "100%",
                    transition: "0.3s",
                    "&:hover": {
                      boxShadow: 4,
                      transform: "translateY(-2px)"
                    }
                  }}
                >
                  <CardContent>
                    <Typography variant="h6">
                      {t("roomTempBlog")}
                    </Typography>

                    <Typography variant="body2" color="text.secondary">
                      {t("roomTempGuidesAll")}
                    </Typography>
                  </CardContent>
                </Card>
              </a>
            </Grid>
          </Grid>
        </Container>
      </Box>

      <Box sx={{ textAlign: "center", py: 6, bgcolor: "#fff" }}>
        <a
          href="https://tinygo.net/"
          target="_blank"
          rel="noopener noreferrer"
          title="TinyGo.net Free Online Tools"
          style={{
            textDecoration: "none",
            color: "inherit",
          }}
        >
          <Box
            sx={{
              display: "inline-block",
              border: "1px solid #e0e0e0",
              borderRadius: 2,
              overflow: "hidden",
              maxWidth: 600,
              backgroundColor: "#fff",
              transition: "all 0.3s ease",
              "&:hover": {
                boxShadow: 3,
                transform: "translateY(-2px)",
              },
            }}
          >
            {/* eslint-disable-next-line jsx-a11y/img-redundant-alt */}
            <img
              src="https://tinygo.net/assets/img/og-image.png"
              alt="TinyGo.net tools for image compression, image resizing, JSON formatting, Base64 conversion and word counting"
              loading="lazy"
              style={{
                width: "100%",
                display: "block",
              }}
            />

            <Box sx={{ p: 3 }}>
              <Typography variant="h5" fontWeight="bold" gutterBottom>
                {t("tinyGoTitle")}
              </Typography>

              <Typography variant="body1" color="text.secondary">
                {t("tinyGoDesc")}
              </Typography>
            </Box>
          </Box>
        </a>
      </Box>

      <Box sx={{ textAlign: "center", py: 6, bgcolor: "#fff" }}>
        <Typography variant="h6" gutterBottom>
          {t("awardRecognition")}
        </Typography>

        <a
          href="https://room-temperature-thermometer-5.updatestar.com/"
          target="_blank"
          rel="dofollow noopener noreferrer"
          style={{ textDecoration: "none", color: "inherit" }}
        >
          <Box sx={{ display: "inline-block", p: 2 }}>
            <img
              src="https://www.updatestar.com/img/rating_4stars.png"
              alt="Very Good Award - UpdateStar"
              style={{ height: 80 }}
            />
            <Typography variant="body2" sx={{ mt: 1, maxWidth: 500 }}>
              {t("awardRecognitionDesc")}
            </Typography>
          </Box>
        </a>
      </Box>

      {/* CTA */}
      <Box
        sx={{
          bgcolor: "#0d1117",
          color: "#fff",
          py: 10,
          textAlign: "center"
        }}
      >
        <Typography variant="h4" component="h2" gutterBottom>
          {t("startMonitoring")}
        </Typography>

        <Typography component="p" sx={{ mb: 3 }}>
          {t("turn2moninmin")}
        </Typography>

        <Button
          variant="contained"
          color="success"
          href="https://play.google.com/store/apps/details?id=asav.roomtemprature"
          target="_blank"
          component="a"
        >
          {t("getApp")}
        </Button>
        <Typography sx={{ mt: 3 }} variant="body2">
          {t("copyright")}
        </Typography>

       
        <Box sx={{ mt: 1 }}>
          <Button
            size="small"
            component="a"
            sx={{ color: "#aaa" }}
            href="/about"
          >
            {t("aboutUs")}
          </Button>

          <Button
            size="small"
            component="a"
            sx={{ color: "#aaa" }}
            href="/contact"
          >
            {t("contact")}
          </Button>

          <Button
            size="small"
            component="a"
            sx={{ color: "#aaa" }}
            href="/policy"
          >
            {t("privacy")}
          </Button>

          <Button
            size="small"
            component="a"
            sx={{ color: "#aaa" }}
            href="/terms"
          >
            {t("terms")}
          </Button>

          <Button
            size="small"
            component="a"
            sx={{ color: "#aaa" }}
            href="/faq"
          >
            {t("faqs")}
          </Button>

          <Button
            color="inherit"
            href="/blog">
            {t("blog")}
          </Button>
        </Box>
      </Box>
    </Box>

  );


  function getTemperatureUnit() {
    const locale = navigator.language || navigator.userLanguage;
    const fahrenheitCountries = ["en-US", "en-BZ", "en-KY"];
    const isFahrenheit = fahrenheitCountries.includes(locale);
    if (isFahrenheit) return "F";
    return "C";
  }
}